import { Download, Link2 } from "lucide-react";
import { toast } from "sonner";

const PHOTO = "/joel-portrait.webp";

const copyVideoLink = async () => {
  const url = `${window.location.origin}/elect-joel-bruce.mp4`;
  try {
    await navigator.clipboard.writeText(url);
    toast.success("Video link copied — share it anywhere.");
  } catch {
    toast.info(`Share this link: ${url}`);
  }
};

export const About = () => {
  return (
    <section id="about" className="scroll-mt-36 border-t border-[#DCDCD6] px-6 py-24 md:scroll-mt-24 md:py-32" data-testid="about-section">
      <div className="mx-auto grid max-w-6xl grid-cols-1 items-start gap-12 md:grid-cols-2">
        <div className="overflow-hidden">
          <img
            src={PHOTO}
            alt="Joel Bruce, candidate for District 3 Collins-Bayridge"
            className="aspect-[4/5] w-full object-cover"
            data-testid="about-photo"
          />
          <p className="mt-3 text-[10px] font-bold uppercase tracking-[0.25em] text-[#666666]">
            Joel Bruce — Collins-Bayridge, District 3
          </p>
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#666666]">About Joel</p>
          <h2 className="mt-4 font-serif text-3xl font-light leading-tight tracking-tight md:text-5xl">
            A Kingstonian, Plain and Simple
          </h2>
          <div className="mt-8 space-y-5 text-base leading-relaxed text-[#666666]">
            <p>
              Joel was born in Kingston and lives in District #3's Westwoods.
              He has watched, with his wife and two young
              children, as population dynamics and associated priorities have
              shifted over the past twenty years. While the
              city has taken some strong steps to sustainable development,
              recent years have shown a lack of leadership expressed
              primarily through missed opportunities.
            </p>
            <p>
              These missed opportunities include both projects that have been
              turned down and others where expenditure outstrips the benefit
              to the community. Our strength is in our local businesses,
              people, and passions. Joel will use his background in the
              Canadian Armed Forces, project management, social service
              delivery, and justice system to ensure decisions are made from
              a diverse perspective.
            </p>
            <p>
              Joel would like to see the city move forward with a
              development plan built on fiscal responsibility, public-private partnership,
              support for local businesses, prioritizing infrastructure
              maintenance, a sustainable transit plan that meets the needs of
              all modes of transportation, and a modified
              diversion-enforcement strategy to address social
              decline in the city.
            </p>
            <p>
              Joel has lived in District #3 for the past 5 years and is well
              aware of the opportunities and shortcomings of the area. From
              the beautify walking paths to the sporadic road maintenance,
              Joel is committed to not simply advocating for, but addressing
              ongoing issues.
            </p>
          </div>
        </div>
      </div>
      <div className="mx-auto mt-14 max-w-6xl" data-testid="campaign-video-link">
        <p className="mb-4 text-center text-xs font-bold uppercase tracking-[0.3em] text-[#666666]">
          Watch — Elect Joel Bruce
        </p>
        <div className="mx-auto aspect-video w-full max-w-3xl overflow-hidden border border-[#DCDCD6] bg-[#111111]">
          <video
            controls
            playsInline
            preload="metadata"
            className="h-full w-full"
            src="/elect-joel-bruce.mp4"
            data-testid="campaign-video-player"
          />
        </div>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-4">
          <a
            href="/elect-joel-bruce.mp4"
            download="Elect-Joel-Bruce.mp4"
            data-testid="campaign-video-download-button"
            className="inline-flex items-center gap-3 border border-[#111111] bg-[#DCDCD6] px-8 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-[#111111] transition-colors duration-300 hover:bg-[#111111] hover:text-[#F4F4F0]"
          >
            Download video
            <Download className="h-4 w-4" />
          </a>
          <button
            onClick={copyVideoLink}
            data-testid="campaign-video-share-button"
            className="inline-flex items-center gap-3 border border-[#111111] bg-[#DCDCD6] px-8 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-[#111111] transition-colors duration-300 hover:bg-[#111111] hover:text-[#F4F4F0]"
          >
            Copy share link
            <Link2 className="h-4 w-4" />
          </button>
        </div>
      </div>
    </section>
  );
};
